// @givmo/passkeys — who is offered an authenticator app on the web (D-AS-26 N2; D-AS-27 R11).
//
// ONLY an account that signs in with Google, Apple or Microsoft, and only while the backend serves
// authenticator apps here (`capabilities.mfa.enabled`, dark in production until R11's last step).
// Everyone else's second step is a passkey: a password, emailed-code or phone-only account never
// meets an authenticator offer, anywhere on the web.
//
// The account's providers are read through the host's `waysIn` — the ways back in its "Confirm it's
// you" sheet can actually run, built from the Firebase account's linked sign-ins. That is also the
// precise condition, not a proxy for it: setting one up needs a fresh sign-in with exactly such a
// provider (Identity Platform refuses enrolment from a custom-token session — a suite handoff, a
// passkey sign-in or a passkey re-confirmation — and from a stale one), so an account with no
// provider way in the sheet could not finish what it was offered.

import type { UserSecurityOut } from '@givmo/api-client';
import type { StepUpOwnWayIn } from '@givmo/step-up';
import { authenticatorAppsServedFrom } from './account-factors';

/** Whether this account may be offered an authenticator app here. */
export function authenticatorAppOffered(
  waysIn: readonly StepUpOwnWayIn[],
  security: UserSecurityOut | undefined,
): boolean {
  return authenticatorAppsServedFrom(security) && waysIn.some((way) => way.kind === 'provider');
}
